const data = {
  id: 1,
  title: 'Match the sounds with the correct words',
  subTitle: 'Nối âm với từ tương ứng',
  question: '',
  answers: [
    { id: 1, answer: 'ball', isCorrect: true, imageUrl: '', audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/5307e239-9ad8-4376-a265-48f89a6c564f.mp3', imageUrl: '' },
    { id: 3, answer: 'hippo', isCorrect: true, imageUrl: '', audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/14655748-d1c2-401a-9e35-023422e5a9f9.mp3', imageUrl: '' },
  ],
};

export default data;
